
































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IActivityStatus } from "@/@types/admin/activity-status";

@Component({})
export default class TvChoose extends Vue {
  @Prop({ type: Array, default: () => [] }) tvs!: Array<IActivityStatus>;
  changeTv: Array<string> = [];

  getChangeTv(id: string | undefined): boolean {
    if (!id) return false;
    return this.changeTv.includes(id) ? true : false;
  }

  addAllTv(): void {
    if (this.tvs.length == this.changeTv.length) {
      this.changeTv = [];
      return;
    }
    this.tvs.forEach((el) => {
      if (el._id && !this.changeTv.includes(el._id)) this.changeTv.push(el._id);
    });
  }

  addATv(id: string | undefined): void {
    if (!id) return;
    const inx = this.changeTv.indexOf(id);
    if (inx == -1) {
      this.changeTv.push(id);
      return;
    }
    this.changeTv.splice(inx, 1);
  }

  @Watch("changeTv", { deep: true })
  updateTVs(): void {
    this.$emit("tvs", this.changeTv);
  }
}
